import React, { Suspense, lazy, useState } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
// icons
import SearchIcon from '@mui/icons-material/Search';
import HelpIcon from '@mui/icons-material/Help';
// lazy
const HelpDialog = lazy(() => import('./HelpDialog'));
function HelpAdornment() {
    const [isHelpDialogDisplayed, setHelpDialogDisplayed] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { onClick: () => setHelpDialogDisplayed(true), size: "small" },
            React.createElement(HelpIcon, { fontSize: "small" })),
        isHelpDialogDisplayed ? (React.createElement(Suspense, { fallback: null },
            React.createElement(HelpDialog, { handleClose: () => setHelpDialogDisplayed(false) }))) : null));
}
export default function EndAdornment({ showHelp, endAdornment, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(InputAdornment, { position: "end", style: { marginRight: 7 } },
            React.createElement(SearchIcon, { fontSize: "small" }),
            showHelp ? React.createElement(HelpAdornment, null) : null),
        endAdornment));
}
